var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 672,
    height: 238,
    viewBox: "0 0 672 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.63 143.43H114.97V211.42H219.63V143.43Z",
    fill: "#7A7671"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M219.63 143.43H114.97V211.42H219.63V143.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.18 143.43H442.52V211.42H547.18V143.43Z",
    fill: "#7A7671"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M547.18 143.43H442.52V211.42H547.18V143.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.96 23.2002H636.5V29.8202C636.5 29.8202 647.35 29.7402 655.15 30.0302C665.72 30.4202 667.27 44.0202 667.27 44.0202L670.87 44.0602V40.4502C670.87 30.9402 662.47 23.2002 652.96 23.2002Z",
    fill: "#F6A722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.93 40.2504V43.4504H664.16C662.29 43.4504 660.77 44.9704 660.77 46.8404V68.5004C660.77 70.0904 662.06 71.3803 663.65 71.3803H668.42C670.01 71.3803 671.3 70.0904 671.3 68.5004V40.1104L666.93 40.2404V40.2504Z",
    fill: "#F6A722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.93 55.4704C666.79 55.4704 666.67 52.5004 666.67 48.8304C666.67 45.1604 666.79 42.1904 666.93 42.1904C667.07 42.1904 667.19 45.1604 667.19 48.8304C667.19 52.5004 667.07 55.4704 666.93 55.4704Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.93 8.95L568.11 3.87C566.28 1.43 563.4 0 560.35 0H388.25C384.6 0 381.21 1.93 379.36 5.08L376.91 9.24L14.4 10.83C8.52003 10.86 3.74003 15.56 3.62003 21.44L0.0300293 201.77L64.2 212.65H125.3C122.43 205.62 121.2 197.75 122.12 189.5C124.62 167.13 143.06 149.49 165.51 147.92C193.04 145.99 215.98 167.76 215.98 194.88C215.98 201.17 214.74 207.16 212.5 212.64H451.45C448.58 205.61 447.35 197.74 448.27 189.49C450.77 167.12 469.21 149.48 491.66 147.91C519.2 145.98 542.13 167.75 542.13 194.87C542.13 201.16 540.89 207.15 538.65 212.63H628.7L640.12 199.03V21.59C640.12 15.68 633.52 9.08 627.61 9.08L571.92 8.96L571.93 8.95Z",
    fill: "#00BAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1799 34.5801V117.32C16.1799 126.03 23.2399 133.1 31.9599 133.1H229.4V36.7901L16.1799 34.5801Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4199 41.0601V87.6401L34.8999 95.1001H120.43V41.1401L23.4199 41.0601Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2 103.11V41.0601H224.11V125.98L207.49 109.36C203.41 105.28 197.87 102.99 192.09 103L128.19 103.11H128.2Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M137.31 103.09L206.19 41.1301L224.11 41.0601L156.48 103.06L137.31 103.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.01 34.5801H350.16V133.1H547.01V34.5801Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.23 39.2002H354.84V127.35H444.23V39.2002Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.32 39.2002H451.93V127.35H541.32V39.2002Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.16 212.62C427.16 212.62 427.14 212.3 427.14 211.69C427.14 211.07 427.13 210.18 427.12 209.03C427.11 206.69 427.09 203.29 427.06 198.97C427.03 190.31 426.99 177.94 426.95 163.03L427.17 163.25C409.65 163.26 388.57 163.28 365.91 163.29L366.17 163.03C366.17 180.95 366.15 197.88 366.14 212.62L365.91 212.39C384.09 212.44 399.37 212.48 410.13 212.51C415.51 212.54 419.75 212.56 422.67 212.57C424.11 212.58 425.23 212.59 426 212.6C426.37 212.6 426.65 212.61 426.86 212.61C427.06 212.61 427.16 212.61 427.16 212.62C427.16 212.63 427.07 212.62 426.89 212.63C426.68 212.63 426.41 212.63 426.05 212.64C425.29 212.64 424.19 212.66 422.76 212.67C419.85 212.68 415.62 212.71 410.27 212.73C399.47 212.76 384.14 212.8 365.9 212.85H365.67V212.62C365.67 197.88 365.65 180.95 365.64 163.03V162.77H365.9C388.56 162.79 409.63 162.8 427.16 162.81H427.38V163.03C427.33 178 427.29 190.41 427.27 199.11C427.25 203.41 427.23 206.8 427.21 209.12C427.2 210.25 427.19 211.13 427.19 211.74C427.19 212.33 427.17 212.62 427.17 212.62H427.16Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.15 212.64C117.15 212.64 117.13 212.52 117.13 212.29C117.13 212.04 117.12 211.7 117.11 211.27C117.11 210.35 117.09 209.02 117.07 207.32C117.05 203.85 117.03 198.84 117 192.58C116.98 179.99 116.95 162.36 116.91 142.08L117.16 142.33C109.99 142.33 102.35 142.33 94.48 142.33C68.74 142.3 45.43 142.27 28.54 142.25C20.12 142.22 13.3 142.19 8.55999 142.17C6.21999 142.15 4.38999 142.13 3.12999 142.12C2.52999 142.11 2.05999 142.1 1.71999 142.09C1.39999 142.09 1.23999 142.06 1.23999 142.06C1.23999 142.06 1.39999 142.04 1.71999 142.03C2.05999 142.03 2.52999 142.02 3.12999 142C4.39999 141.99 6.21999 141.97 8.55999 141.95C13.3 141.93 20.12 141.9 28.54 141.87C45.43 141.85 68.74 141.82 94.48 141.79C102.35 141.79 109.99 141.79 117.16 141.79H117.41V142.04C117.37 162.32 117.34 179.96 117.32 192.54C117.29 198.81 117.26 203.81 117.25 207.28C117.23 208.98 117.22 210.31 117.21 211.23C117.21 211.66 117.19 212 117.19 212.25C117.19 212.48 117.18 212.6 117.17 212.6L117.15 212.64Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8 143.43C66.94 143.43 67.06 158.91 67.06 178.01C67.06 197.11 66.94 212.59 66.8 212.59C66.66 212.59 66.54 197.11 66.54 178.01C66.54 158.91 66.66 143.43 66.8 143.43Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1201 142.61C18.2601 142.61 18.3801 156.49 18.3801 173.62C18.3801 190.75 18.2601 204.63 18.1201 204.63C17.9801 204.63 17.8601 190.75 17.8601 173.62C17.8601 156.49 17.9801 142.61 18.1201 142.61Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.22 197.48C110.22 197.48 110.22 197.4 110.21 197.26C110.21 197.1 110.21 196.9 110.2 196.64C110.2 196.07 110.18 195.27 110.17 194.24C110.16 192.13 110.14 189.07 110.11 185.21C110.08 177.46 110.04 166.46 109.99 153.34L110.22 153.57C98.91 153.57 85.8 153.59 71.89 153.6C71.83 153.65 72.38 153.11 72.15 153.35V156.38C72.15 157.39 72.15 158.39 72.15 159.39C72.15 161.39 72.15 163.37 72.15 165.32C72.15 169.23 72.15 173.05 72.15 176.76C72.14 184.17 72.13 191.14 72.12 197.48L71.9 197.26C83.4 197.31 92.95 197.35 99.66 197.37C103 197.39 105.63 197.41 107.45 197.43C108.33 197.44 109.02 197.45 109.51 197.46C109.98 197.46 110.23 197.48 110.23 197.48C110.23 197.48 110.01 197.5 109.55 197.5C109.07 197.5 108.39 197.51 107.53 197.53C105.72 197.54 103.11 197.56 99.79 197.59C93.05 197.62 83.45 197.66 71.89 197.7H71.67V197.48C71.67 191.14 71.65 184.17 71.64 176.76C71.64 173.05 71.64 169.23 71.64 165.32C71.64 163.36 71.64 161.39 71.64 159.39C71.64 158.39 71.64 157.39 71.64 156.38V154.86V154.1V153.36C71.41 153.58 71.96 153.02 71.9 153.08C85.82 153.09 98.93 153.1 110.23 153.11H110.46V153.34C110.41 166.52 110.37 177.57 110.34 185.36C110.31 189.2 110.29 192.23 110.28 194.34C110.27 195.35 110.26 196.14 110.25 196.69C110.25 196.94 110.25 197.13 110.24 197.29C110.24 197.42 110.24 197.49 110.23 197.48H110.22Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.56 153.34C76.7 153.34 76.82 163.22 76.82 175.41C76.82 187.6 76.7 197.48 76.56 197.48C76.42 197.48 76.3 187.6 76.3 175.41C76.3 163.22 76.42 153.34 76.56 153.34Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3601 153.34C82.5001 153.34 82.6201 163.22 82.6201 175.41C82.6201 187.6 82.5001 197.48 82.3601 197.48C82.2201 197.48 82.1001 187.6 82.1001 175.41C82.1001 163.22 82.2201 153.34 82.3601 153.34Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1601 153.34C88.3001 153.34 88.4201 163.22 88.4201 175.41C88.4201 187.6 88.3001 197.48 88.1601 197.48C88.0201 197.48 87.9001 187.6 87.9001 175.41C87.9001 163.22 88.0201 153.34 88.1601 153.34Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.96 153.34C94.1 153.34 94.22 163.22 94.22 175.41C94.22 187.6 94.1 197.48 93.96 197.48C93.82 197.48 93.7 187.6 93.7 175.41C93.7 163.22 93.82 153.34 93.96 153.34Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.75 153.34C99.89 153.34 100.01 163.22 100.01 175.41C100.01 187.6 99.89 197.48 99.75 197.48C99.61 197.48 99.49 187.6 99.49 175.41C99.49 163.22 99.61 153.34 99.75 153.34Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.55 153.34C105.69 153.34 105.81 163.22 105.81 175.41C105.81 187.6 105.69 197.48 105.55 197.48C105.41 197.48 105.29 187.6 105.29 175.41C105.29 163.22 105.41 153.34 105.55 153.34Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.68 46.4102H236.98V212.65H341.68V46.4102Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.63 57.8003H242.82V187.84H282.63V57.8003Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.05 57.8003H295.24V187.84H335.05V57.8003Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.16 46.4102C289.3 46.4102 289.42 83.3502 289.42 128.91C289.42 174.47 289.3 211.42 289.16 211.42C289.02 211.42 288.9 174.49 288.9 128.91C288.9 83.3302 289.02 46.4102 289.16 46.4102Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.4701 41.0601L25.0901 88.7601L34.9001 95.1001L98.2101 41.0601H83.4701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M46.25 95.0999L109.43 41.1299H113.03L50.07 95.0999H46.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M354.84 99.6902L422.01 39.2702L439.92 39.2002L354.64 117.38L354.84 99.6902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M242.82 137.78V155.3L282.63 118.8V101.97L242.82 137.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M295.24 158.63V176.15L335.05 139.65V122.82L295.24 158.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.3 57.7998L295.24 73.1398V90.6598L331.08 57.7998H312.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M242.81 161.99L242.74 167.73L282.63 131.6V126.54L242.81 161.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.78 46.4102H557.21V212.65H619.78V46.4102Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.94 57.8003H563.06V187.84H612.94V57.8003Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M612.94 57.7998H593.62V161.83H612.94V57.7998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M563.08 137.78V155.3L612.94 118.8V101.97L563.08 137.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M563.06 161.99L562.98 167.73L612.94 131.6V126.54L563.06 161.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M453.48 100.26L521.35 39.2002H540.2L453.28 117.95L453.48 100.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M451.93 127.83L537.71 48.1699H541.32L455.75 127.83H451.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.88 47.29H23.4199V49.05H224.88V47.29Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.45 47.29H353.11V49.05H545.45V47.29Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.25 155.3H542.79C541.327 155.3 540.14 156.486 540.14 157.95V158.13C540.14 159.593 541.327 160.78 542.79 160.78H547.25C548.714 160.78 549.9 159.593 549.9 158.13V157.95C549.9 156.486 548.714 155.3 547.25 155.3Z",
    fill: "#5391DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.51 187.82H435.05C433.586 187.82 432.4 189.006 432.4 190.47V190.65C432.4 192.113 433.586 193.3 435.05 193.3H439.51C440.973 193.3 442.16 192.113 442.16 190.65V190.47C442.16 189.006 440.973 187.82 439.51 187.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.78 187.82H351.32C349.856 187.82 348.67 189.006 348.67 190.47V190.65C348.67 192.113 349.856 193.3 351.32 193.3H355.78C357.243 193.3 358.43 192.113 358.43 190.65V190.47C358.43 189.006 357.243 187.82 355.78 187.82Z",
    fill: "#5391DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.74 187.37H222.28C220.816 187.37 219.63 188.557 219.63 190.02V190.2C219.63 191.664 220.816 192.85 222.28 192.85H226.74C228.203 192.85 229.39 191.664 229.39 190.2V190.02C229.39 188.557 228.203 187.37 226.74 187.37Z",
    fill: "#5391DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7399 192.84H24.2799C22.8163 192.84 21.6299 194.026 21.6299 195.49V195.67C21.6299 197.133 22.8163 198.32 24.2799 198.32H28.7399C30.2034 198.32 31.3899 197.133 31.3899 195.67V195.49C31.3899 194.026 30.2034 192.84 28.7399 192.84Z",
    fill: "#5391DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M581.24 57.7998V119.39H563.08L563.06 57.7998H581.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.13 30.3999H627.62V153.57H640.13V30.3999Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.14 143.07C640.14 143.07 633.78 144.7 632.16 139C630.53 133.31 632.16 34.5698 632.16 34.5698H640.14V143.06V143.07Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M631.43 96.8102L640.14 90.3602V78.8702C640.14 77.9202 631.43 83.8502 631.43 83.8502V96.8202V96.8102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M403.05 0.5H400.81V5.85H403.05V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M407.32 0.5H405.08V5.85H407.32V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M411.58 0.5H409.34V5.85H411.58V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M415.84 0.5H413.6V5.85H415.84V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M420.1 0.5H417.86V5.85H420.1V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M424.37 0.5H422.13V5.85H424.37V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M428.63 0.5H426.39V5.85H428.63V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M432.89 0.5H430.65V5.85H432.89V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M437.15 0.5H434.91V5.85H437.15V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M441.42 0.5H439.18V5.85H441.42V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M445.68 0.5H443.44V5.85H445.68V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M449.94 0.5H447.7V5.85H449.94V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M454.2 0.5H451.96V5.85H454.2V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M458.47 0.5H456.23V5.85H458.47V0.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.29 8.94994C572.29 9.08994 528.48 9.20994 474.45 9.20994C420.42 9.20994 376.6 9.08994 376.6 8.94994C376.6 8.80994 420.4 8.68994 474.45 8.68994C528.5 8.68994 572.29 8.80994 572.29 8.94994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.14 28.3699C640.14 28.5099 497.61 28.6299 321.83 28.6299C146.05 28.6299 3.48999 28.5099 3.48999 28.3699C3.48999 28.2299 145.99 28.1099 321.83 28.1099C497.67 28.1099 640.14 28.2299 640.14 28.3699Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29 234.4C191.288 234.4 207.5 218.188 207.5 198.19C207.5 178.192 191.288 161.98 171.29 161.98C151.292 161.98 135.08 178.192 135.08 198.19C135.08 218.188 151.292 234.4 171.29 234.4Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.36 175.31H628.73V186.78H635.36V175.31Z",
    fill: "#5391DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.16 175.31H635.36V186.78H640.16V175.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.55 9.62012H234.18V39.2001H345.55V9.62012Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M341.67 12.79H237.65V36.02H341.67V12.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32 194.99C126.99 217.96 145.34 236.84 168.3 237.17C191.27 237.5 210.15 219.15 210.48 196.19C210.81 173.22 192.46 154.34 169.5 154.01C146.53 153.68 127.65 172.03 127.32 194.99Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.33 194.88C127.33 194.88 127.33 194.95 127.33 194.99C127 217.96 145.35 236.84 168.31 237.17C191.28 237.5 210.16 219.15 210.49 196.19C210.49 196.15 210.49 196.12 210.49 196.08L127.33 194.88Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71 195.17C139.48 211.29 152.36 224.55 168.48 224.79C184.6 225.02 197.86 212.14 198.1 196.02C198.33 179.9 185.45 166.64 169.33 166.4C153.21 166.17 139.95 179.05 139.72 195.17H139.71Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.33 166.39C153.21 166.16 139.95 179.04 139.72 195.16L198.11 196C198.34 179.88 185.46 166.62 169.34 166.38L169.33 166.39Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.12 195.33C150.98 205.15 158.83 213.23 168.65 213.37C178.47 213.51 186.55 205.66 186.69 195.84C186.83 186.02 178.98 177.94 169.16 177.8C159.34 177.66 151.26 185.51 151.12 195.33Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.662 237.111C520.611 236.157 538.443 216.78 537.489 193.83C536.535 170.88 517.157 153.049 494.207 154.003C471.258 154.957 453.427 174.334 454.38 197.284C455.334 220.234 474.712 238.065 497.662 237.111Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.34 194.88C454.34 194.88 454.34 194.95 454.34 194.99C454.01 217.96 472.36 236.84 495.32 237.17C518.29 237.5 537.17 219.15 537.5 196.19C537.5 196.15 537.5 196.12 537.5 196.08L454.34 194.88Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.72 195.17C466.49 211.29 479.37 224.55 495.49 224.79C511.61 225.02 524.87 212.14 525.11 196.02C525.34 179.9 512.46 166.64 496.34 166.4C480.22 166.17 466.96 179.05 466.73 195.17H466.72Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.34 166.39C480.22 166.16 466.96 179.04 466.73 195.16L525.12 196C525.35 179.88 512.47 166.62 496.35 166.38L496.34 166.39Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.13 195.33C477.99 205.15 485.84 213.23 495.66 213.37C505.48 213.51 513.56 205.66 513.7 195.84C513.84 186.02 505.99 177.94 496.17 177.8C486.35 177.66 478.27 185.51 478.13 195.33Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.44 41.0601H23.4199V43.8001H120.44V41.0601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M224.11 41.0601H128.2V43.8001H224.11V41.0601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M335.05 57.7998H242.82V60.5398H335.05V57.7998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M541.31 39.2002H354.84V41.9402H541.31V39.2002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1001 10.6099L68.7301 7.29988C70.7901 5.41988 73.4701 4.37988 76.2501 4.37988H123.41C126.47 4.37988 129.39 5.62988 131.49 7.84988L134.12 10.6099H65.1001Z",
    fill: "#F6A722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3 10.6101C137.3 10.7501 120.85 10.8701 100.55 10.8701C80.2501 10.8701 63.8 10.7501 63.8 10.6101C63.8 10.4701 80.2501 10.3501 100.55 10.3501C120.85 10.3501 137.3 10.4701 137.3 10.6101Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75003 194.88H0.0300293L0.840029 160.99H9.86003V190.77C9.86003 193.04 8.02003 194.88 5.75003 194.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.22 142.08C1.22 142.08 1.25 142.29 1.25 142.69C1.25 143.14 1.25 143.72 1.23 144.43C1.2 146.01 1.16 148.18 1.12 150.82C1.06 156.28 0.98 163.71 0.89 171.92C0.82 180.16 0.69 187.63 0.5 193.03C0.41 195.73 0.31 197.91 0.22 199.42C0.17 200.13 0.14 200.7 0.11 201.16C0.08 201.56 0.05 201.76 0.03 201.76C0.01 201.76 0 201.55 0 201.15C0 200.7 0 200.12 0.02 199.41C0.05 197.83 0.09 195.66 0.13 193.02C0.19 187.56 0.27 180.13 0.37 171.92C0.44 163.68 0.57 156.22 0.76 150.82C0.85 148.12 0.95 145.94 1.04 144.43C1.09 143.72 1.12 143.15 1.15 142.69C1.18 142.29 1.21 142.09 1.23 142.09L1.22 142.08Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.14 153.57C640.28 153.56 640.38 156.11 640.44 160.23C640.5 164.35 640.51 170.03 640.49 176.31C640.47 182.59 640.41 188.28 640.35 192.39C640.31 194.38 640.28 196.03 640.25 197.26C640.22 198.41 640.18 199.05 640.15 199.05C640.11 199.05 640.08 198.41 640.05 197.26C640.03 196.02 640.01 194.38 639.98 192.39C639.95 188.27 639.94 182.59 639.97 176.31C640.06 164.48 640.13 156.29 640.15 153.58L640.14 153.57Z",
    fill: "#1A2E35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 671.3,
    height: 237.17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrt);
export default __webpack_public_path__ + "static/media/brt.eacc3cf894ece6a28ee365c04ae1e333.svg";
export { ForwardRef as ReactComponent };